import React, { Component } from "react";

import ComponentHOC from "../hoc/ComponentHOC";
//Components imports
import EntertaimentCardItem from "./entertainment-card";
import Project from "../models/projects";
import PropTypes from "prop-types";
import { connect } from "react-redux";

class EntertainmentComponent extends Component {
  constructor() {
    super();
    this.state = {
      colSize: 2,
    };
  }
  componentDidMount() {
    this.updateValues();
  }
  componentDidUpdate(prev) {
    const { screenWidth } = this.props;
    if (screenWidth != prev.screenWidth) this.updateValues();
  }
  updateValues() {
    const { screenWidth, sizes } = this.props;

    for (var [key, value] of Object.entries(sizes)) {
      if (screenWidth >= key)
        this.setState({
          colSize: value,
        });
    }
  }
  getTitleName(title) {
    var name = title.toLowerCase().replace(/ +/g, "-");
    return name;
  }
  render() {
    const { list } = this.props;
    const { colSize } = this.state;

    return (
      <section className="entertainment-section projects">
        <div className="container entertainment">
          <div className="row entertainment-card-list">
            {list.map((cardItem, index) => {
              var item = new Project(cardItem);
              //   if (window.location.pathname === "/" && index >= colSize) {
              //     console.log(item.title);
              //     return null;
              //   }
              return (
                <EntertaimentCardItem
                  key={item.id}
                  src={item.src}
                  title={item.title}
                  width={12 / colSize}
                  link={`projetos/${item.id}/${this.getTitleName(item.title)}`}
                />
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}
EntertainmentComponent.propType = {
  size: PropTypes.number,
  list: PropTypes.array.isRequired,
};

export default connect((state) => state)(ComponentHOC(EntertainmentComponent));



// WEBPACK FOOTER //
// ./src/components/entertainment.js